import styled from 'styled-components';
import { palette } from 'theme/MainTheme';

import { MoreOutlined } from '@ant-design/icons';
import { borderRadius } from 'library/helpers/style_utils';
const DeviceCardWrapper = styled.div`
	display: flow-root;
	width: inherit;
	overflow: auto;
	margin-bottom: 4px;

	.ant-card {
		width: auto;
		background-color: ${palette('secondary', 7)};
		border-radius: 4px;
	}

	.customIcon {
		display: inline-block;
		margin-left: 5px;
		font-size: 24px;
	}
	.wordFix {
		overflow-wrap: break-word;
		max-width: 220px;
		display: flex;
	}

	.spanFix {
		cursor: pointer;
		max-width: 220px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		word-break: break-all;
		display: inline-block;
		line-height: 16px;
	}

	.ant-card-hoverable {
		cursor: default;
	}
	.customCard {
		max-width: 315px;
		overflow: auto;
		background-color: ${palette('secondary', 7)};
		border-radius: 4px;
		border: 2px transparent solid !important;
	}
	.customCard:hover {
		border: 2px ${palette('secondary', 0)} solid !important;
	}
	.ant-card-bordered {
		border-color: ${palette('grayscale', 2)};
		${borderRadius()};
	}
	.ant-card-actions {
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}
	.ant-card-actions > li {
		margin: 0;
	}

	.ant-card-head {
		border-bottom-color: ${palette('grayscale', 3)};

		.ant-card-head-title {
			font-size: 18px;
			color: ${palette('secondary', 0)};
			padding: 8px 0px 0px 0px !important;
		}
		.ant-card-extra {
			padding: 8px 0px 0px 0px !important;
		}
		.ant-card-extra > span {
			font-size: 18px;
			padding: 10px;
			margin-right: -15px;
		}
	}
	.ant-card-body {
		padding: 8px 12px !important;
	}

	.stat {
		min-width: 65px;
		padding-left: 5px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		align-items: center;
	}

	.imageIcon {
		width: 15px;
		margin-left: 5px;
		font-size: 14px;
	}

	.infoTitles {
		font-size: 10px;
		font-weight: 400;
		margin: 0 7px;
	}

	.infoValues {
		font-size: 10px;
		font-weight: 600;
		margin: 0 7px;
		margin-bottom: 5px;
	}
`;

const MoreOutlinedIcon = styled(MoreOutlined)`
	&:hover {
		cursor: pointer;
	}
`;

export { MoreOutlinedIcon };
export default DeviceCardWrapper;
